import {
  Box,
  Button,
  ButtonProps,
  Center,
  Icon,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import { MdOutlineStickyNote2 } from "react-icons/md";

export const EmptySubject = (props: Pick<ButtonProps, "onClick">) => {
  return (
    <Box px={{ base: 5, md: 0 }}>
      <Center
        width="full"
        rounded="lg"
        borderWidth="xs"
        borderColor="green.400"
        borderStyle="dashed"
        bg="green.50"
        minH={{ base: "sm", md: "md" }}
        p={8}
      >
        <VStack spacing={12}>
          <Stack
            maxW={{ base: "xs", md: "xs" }}
            mx="auto"
            textAlign="center"
            align="center"
          >
            <Box py={4}>
              <Icon
                color="green.600"
                as={MdOutlineStickyNote2}
                fontSize={{ base: "4xl", md: "5xl" }}
              />
            </Box>
            <Text
              pb={2}
              lineHeight="shorter"
              fontSize={{ base: "xl", md: "2xl" }}
              fontWeight="semibold"
            >
              You've not added subjects to your profile
            </Text>
            <Text color="gray.600" fontSize={{ base: "sm", md: "md" }}>
              Add subjects to get bookings
            </Text>
          </Stack>
          <Button
            size="lg"
            colorScheme="green"
            isFullWidth
            onClick={props.onClick}
          >
            Add your first subject
          </Button>
        </VStack>
      </Center>
    </Box>
  );
};
